export enum TimelineState {
  PEND = 'Pend',
  PLAY = 'Play',
  PAUSE = 'Pause',
  STOP = 'Stop',
}

export default TimelineState;
